(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function updateHeaderButtons() {
      document.querySelectorAll('[data-bm-header-section]').forEach((section) => {
        // Rebuild on section reload without leaving duplicate or stale buttons.
        section.querySelectorAll('.bm-header-button').forEach((button) => button.remove());
        const source = section.querySelector('.hdt-article-content a[data-header-button]');
        const href = source ? (source.getAttribute('href') || '').trim() : '';
        if (!href) return;

        // Accept web URLs and store-relative links only.
        let url;
        try {
          url = new URL(href, window.location.href);
        } catch (_) {
          return;
        }
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return;

        section.querySelectorAll('.bm-header-image').forEach((image) => {
          const button = document.createElement('a');
          button.className = 'bm-header-button';
          button.href = url.href;
          button.textContent = source.textContent.trim() || 'Mehr erfahren';
          image.appendChild(button);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateHeaderButtons, { once: true });
    } else {
      updateHeaderButtons();
    }
    document.addEventListener('shopify:section:load', updateHeaderButtons);
  })();

  } catch(e) { console.error(e); }
})();
})();
